// 环境配置
const baseEnv = [
  {
    path: '/analy/runtime',
    component: () => import(/* webpackChunkName: "runtime" */ '@/views/analy/runtime'),
    meta: {
      title: '实时监控',
    },
  },
  {
    path: '/analy/daily',
    component: () => import(/* webpackChunkName: "daily" */ '@/views/analy/daily'),
    meta: {
      title: '日常监控',
    },
  },
  {
    path: '/analy/computer',
    component: () => import(/* webpackChunkName: "computer" */ '@/views/analy/computer'),
    meta: {
      title: '监控电脑',
    },
  },
  {
    path: '/analy/usage',
    component: () => import(/* webpackChunkName: "computer" */ '@/views/analy/usage'),
    meta: {
      title: '使用统计',
    },
  },
];

export default baseEnv;
